import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { ParkingPointsOfInterest } from 'src/features/parkingManagement/types/parking';
import type { ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/parking-point-of-interests/ ';

type QueryFnType = typeof queryFn;
const queryFn = (): Promise<ListResponseSmartParkAPI<ParkingPointsOfInterest>> => {
    return axios.get(formatResourcePath(RESOURCE));
};

interface UseQueryHookOptions {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE],
        queryFn: async () => await queryFn(),
        ...config,
    });

export { useQueryHook as useGetListPointsOfInterest };
